import { create } from "zustand"

const initialState = {
  myFilteredRecordsMap: {
    studies: new Set(), // studies
    requests: new Set(), // requests
  },
  isFilterOn: false,
}

const useChatbotStore = create((set) => ({
  ...initialState,
  setMyFilteredRecordsMap: (myFilteredRecordsMap) => set({ myFilteredRecordsMap }),
  setIsFilterOn: (isFilterOn) => set({ isFilterOn }),
}))

export default useChatbotStore
